// Initialize Firebase
export const config = {
  apiKey: "AIzaSyDiLG2CbyuBjm1YHw253iQk0zjmFEAyoSo",
  authDomain: "infovis-838ec.firebaseapp.com",
  databaseURL: "https://infovis-838ec.firebaseio.com",
  projectId: "infovis-838ec",
  storageBucket: "infovis-838ec.appspot.com",
  messagingSenderId: "453826263185"
};